<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4"></div>

      <div class="col-lg-4">
        <div class="card">
          <p class="title">Account verwijderen</p>

          <div class="delete-profile-form">
            <p>Wanneer je je account verwijderd zal alle data omtrent beweegbuddies, klassen, scholen, activiteiten en
              agandavoorbereidingen gewist worden.</p>
            <p>Ben je zeker dat je je account wil verwijderen?</p>

            <v-button class="save-changes-button" buttonText="Account behouden" v-on:clicked="cancelClicked"
                      :enabled="true"></v-button>
            <v-button class="save-changes-button" buttonText="Account verwijderen" v-on:clicked="deleteUserAccount"
                      :enabled="true" :styleType="'button-orange'"></v-button>

          </div>
        </div>
      </div>

      <div class="col-lg-4"></div>

    </div>
  </div>
</template>

<script>
import VButton from "@/components/UI/VButton";
import { AuthApi } from "sandpiper_api";
import log from "@/utils/logger";
import AuthMixin from "@/mixins/AuthMixin";

export default {
  name: "DeleteProfile",
  components: { VButton },
  mixins: [ AuthMixin ],
  inject: [ "doApiRequest" ],
  data()
  {
    return {
      executingRequest: false
    };
  },
  methods: {
    cancelClicked()
    {
      this.$router.push({ name: "profile" });
    },
    async deleteUserAccount()
    {
      try
      {
        this.executingRequest = true;
        await this.doApiRequest(() => new AuthApi().disableAccount(this.currentUserId));
        await this.$router.push({ name: 'logout' });

      }
      catch (e)
      {
        log.error("Failed to delete account - %o", e);
      }
      finally
      {
        this.executingRequest = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card
{
  background-color: white;
  border-radius: 5px;
  box-shadow: $default-shadow;
  padding: 25px;
  margin-top: 25px;
  //min-width: 402px;

  .title
  {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.save-changes-button
{
  margin-bottom: 25px;
}

.cancel-button
{
  align-self: center;
}

.delete-profile-form
{
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}
</style>